import axios from "axios"
import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"
import { toast } from "react-toastify";

// Create course
export const createAssessment = data => post(url.CREATE_ASSESSMENT, data);
export const getQuestionsByAssessment = data => post(url.GET_QUESTION_BY_ASSESSMENT, data);
export const deleteAssessment = id => del(url.DELETE_ASSESSMENT + id);

